import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { usePeriodChartsDataContext } from './hooks/usePeriodChartsDataContext';

export const OcurrencesByDay = () => {
    const { chartData } = usePeriodChartsDataContext();

    return (
        <SimpleBars
            title={'Ocorrências por período (Dias da semana)'}
            horizontal={false}
            subtitles={chartData?.ocurrencesByDay?.map((item) => item.description)}
            values={chartData?.ocurrencesByDay?.map((item) => item.total || 0)}
        />
    );
};